<template>
  <div>
    <md-field>
      <tree :setting="setting" :nodes="treeData" @onCreated="handleCreated" ref="tree" class="md-tree" />
    </md-field>

    <md-field>
      <label>动作</label>
      <md-select v-model="form.templateId">
        <md-option :value="item.id" v-for="item in actionList" :key="item.id">{{ item.name }}</md-option>
      </md-select>
    </md-field>

    <md-field v-if="template === 'tag'">
      <label>内容</label>
      <md-input v-model="form.tipContent" type="text"></md-input>
    </md-field>
    <md-field v-if="template === 'tag'">
      <label>时长</label>
      <md-input v-model="form.tipShowTime" type="text"></md-input>
    </md-field>
    <div class="md-layout" v-if="template === 'tag'">
      <div class="md-layout-item md-size-10">
        <label>位置</label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>x</label>
          <md-input v-model="form.tipPositionX" type="text"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>y</label>
          <md-input v-model="form.tipPositionY" type="text"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field v-if="template === 'tag'">
          <label>z</label>
          <md-input v-model="form.tipPositionZ" type="text"></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
import tree from "vue-giant-tree";
import { findTypeListBySceneId } from "@/api/device";
import { innerAction } from "../../SystemAction";
import { sceneAction } from "../../SceneAction";

let dataMap = {}
let ztreeObj = {}

export default {
  components: {
    tree,
  },
  data() {
    return {
      form: {
        defaultValue: false
      },
      pagination: {
        perPage: 1000,
        currentPage: 1
      },
      list: [],
      treeData: [],
      actionMap: {},
      actionList: [],
      disabled: false,
      setting: {
        check: {
          //树是否带复选框或者单选框
          enable: false,
        },
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id，一般是后台数据库主键
            idKey: "id",
            //父级id
            pIdKey: "pid",
            rootPId: "0",
          },
        },
        //ztree回调函数
        callback: {
          //树选择事件
          onClick: this.treeNodeClick,
        },
      },
    }
  },
  computed: {
    template() {
      const temp_id = this.form.templateId
      if (temp_id && this.actionMap[this.form.structId]) {
        const act = this.actionMap[this.form.structId].find((item) => item.id === temp_id)
        return act ? act.template : ''
      }
      return ''
    }
  },
  watch: {
    'form.templateId'(val) {
      if (val) {
        const arr = this.actionMap[this.form.structId]
        if (!arr || !arr.find) return;
        const act = arr.find((item) => item.id === val)
        const { animResource, playSpeed, replay } = act
        this.form.animResource = animResource
        this.form.playSpeed = playSpeed
        this.form.replay = replay ?? false
        this.form.typeId = act._id
        this.form.actionData = act
        this.form.templateName = act.name
        this.disabled = act.type === 'static'
      }
    }
  },
  inject: ["taskInfo"],
  mounted() {
    this.treeData = this.taskInfo.sceneTreeData
    this.getList()
  },
  methods: {
    init(form) {
      this.form = form;
    },
    handleCreated(obj) {
      ztreeObj = obj;
      let uuuid = this.form.structId
      let nodes = obj.getNodes()
      let setModel = (l) => {
        l.forEach((v) => {
          if (v.id === uuuid) {
            let tId = v.tId

            ztreeObj.refresh()

            let nodeList = ztreeObj.getNodesByParam('id', uuuid) //模糊搜索
            if (nodeList[0]) {
              let parentList = ztreeObj.getNodesByParam('id', nodeList[0].pid)
              if (parentList[0]) {
                ztreeObj.expandNode(parentList[0], true, false, false)
              }
            }
            this.$nextTick(() => {
              let dom = document.getElementById(tId + '_a')
              if (dom) {
                dom.click()
              }
            })
          }
          if (v.children && v.children.length !== 0) {
            setModel(v.children)
          }
        })
      }
      setModel(nodes)
    },
    getList() {

      findTypeListBySceneId({ sceneId: this.taskInfo.taskInfo.scene, type: 'scene' }).then((res) => {
        this.list = res.data;

        this.actionMap = res.data.reduce((pre, next) => {
          pre[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.actions
            : [];

          pre[next.structId] = pre[next.structId].map(item => {
            item._id = next.deviceTypeInfo._id
            return item
          })

          const systemInnerAction = innerAction.flatMap(item => item.action_list).map(item => {
            item.type = 'system_inner'
            return item
          })

          const sceneInnerAction = sceneAction.flatMap(item => item.action_list).map(item => {
            item.type = 'system_inner'
            return item
          })

          pre[next.structId] = pre[next.structId].concat(systemInnerAction).concat(sceneInnerAction)
          return pre;
        }, {});

        if (this.form && this.form.structId) {
          this.actionList = this.actionMap[this.form.structId]
        }

        dataMap = res.data.reduce((pre, next) => {
          pre[next.structId] = next;
          return pre;
        }, {});

      })

    },
    treeNodeClick(obj, id, treeNode) {
      this.form.structId = treeNode.id
      if (dataMap[treeNode.id]) {
        this.form._id = dataMap[treeNode.id]._id
      }
      this.actionList = this.actionMap[treeNode.id]
    }
  }
}
</script>

<style>

</style>
